// src/App.js
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./router/Routes";
import { AuthProvider } from "./context/AuthContext";

const App = () => {
  return (
    <React.StrictMode>
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </React.StrictMode>
  );
};

export default App;
